export const FORM = 'modelConfiguration'

export const FORM_CONFIG = {
    form: FORM,
    // Used for processNumParts and processInspectionCriteria fields
    enableReinitialize: true,
    // Necessary for Quantity field ability to delete entire value in input
    keepDirtyOnReinitialize: true,
    // We destroy the reduxForm only when we close the ConfigurationModal
    // (see onCancel passed to Modal in ConfigurationModal)
    // If this is set to true, switching from the Configuration
    // to the Additional requirements tab causes the Quantity field in the
    // Additional requirements tab to not initialize with a value
    destroyOnUnmount: false,
}
